import { render } from "./TabMenu.vue?vue&type=template&id=26800579&scoped=true"
const script = {}

import "./TabMenu.vue?vue&type=style&index=0&id=26800579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26800579"]])

export default __exports__